import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Seo from "../components/Seo";


const HowToApply = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: false, mirror: true });

    const handleScroll = () => {
      document.querySelectorAll('.step-card').forEach((card) => {
        const cardTop = card.getBoundingClientRect().top;
        if (cardTop < window.innerHeight * 0.8) {
          card.classList.add('active');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>

    <Seo
        title="How to Apply for a Loan - Step-by-Step Guide | Mortbuzz"
        description="Learn how to apply for a home loan, personal loan, business loan, car loan, or education loan with Mortbuzz. Step-by-step guide to a smooth loan application process."
        keywords="how to apply for loan, loan application guide, home loan application, personal loan apply, business loan apply, car loan apply, education loan process"
        canonical="https://www.mortbuzz.in/how-to-apply"
      />

      <section className="hero position-relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #00c6ff, #0072ff)', color: 'white' }}>
        <div className="container py-5 text-white text-center">
          <div className="parallax-bg"></div>
          <h1 className="display-3 fw-bold mb-4 animate__animated animate__fadeInDown" data-aos="zoom-in">
            <i className="bi bi-house-door-heart"></i><br />
            Your Dream Home Journey<br />with MortBuzz<br />How To Apply For Home Loan
          </h1>
          <div className="floating-phone" data-aos="fade-up" data-aos-delay="300">
            <i className="bi bi-phone fs-1"></i>
          </div>
        </div>
      </section>

      <div className="container py-5">
        <h2 className="text-center mb-5 display-4 fw-bold text-primary" data-aos="fade-up">
          3 Simple Steps to Your Home Loan
        </h2>

        <div className="row g-5 steps-timeline">
          {[{
            icon: 'bi-pencil-square',
            title: 'Online Application',
            text: 'Fill our 5-minute digital form with basic details'
          }, {
            icon: 'bi-file-check',
            title: 'Call From Our Expert',
            text: 'Our Field Expert Direct Call You'
          }, {
            icon: 'bi-celebrate',
            title: 'Instant Approval',
            text: 'Get approval within 24 hours & disbursal in 72 hours'
          }].map((step, index) => (
            <div className="col-md-4" data-aos="flip-left" data-aos-delay={index * 200} key={index}>
              <div className="step-card shadow-lg">
                <div className="step-number">{index + 1}</div>
                <i className={`bi ${step.icon} step-icon`}></i>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
                {index !== 2 && <div className="step-arrow"></div>}
              </div>
            </div>
          ))}
        </div>

        <div className="cta-section mt-5 py-5 text-center" data-aos="zoom-in" style={{ background: 'linear-gradient(135deg, #00c6ff, #0072ff)', color: 'white' }}>
          <h2 className="text-white mb-4">Ready to Begin?</h2>
          <button className="btn btn-light btn-lg pulse">
            Apply Now <i className="bi bi-arrow-right"></i>
          </button>
        </div>

        <div className="row g-4 mt-5">
          {[{
            icon: 'bi-piggy-bank-fill',
            title: '100% Agreement Value Financing'
          }, {
            icon: 'bi-bank',
            title: 'Trusted Banks'
          }, {
            icon: 'bi-percent',
            title: 'Lowest Interest Rates'
          }, {
            icon: 'bi-door-open',
            title: 'Door Step Service'
          }].map((feature, index) => (
            <div className="col-md-6 col-lg-3" data-aos="fade-up" key={index}>
              <div className="feature-card">
                <i className={`bi ${feature.icon}`}></i>
                <h4>{feature.title}</h4>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        .hero {
          min-height: 80vh;
          text-shadow: 0 0 10px rgba(0, 0, 0, 0.689);
        }
        .floating-phone {
          animation: float 3s ease-in-out infinite;
        }
        .step-card {
          background: white;
          border-radius: 20px;
          padding: 2rem;
          position: relative;
          transition: all 0.5s ease;
        }
        .step-card:hover {
          transform: translateY(-20px) scale(1.05);
        }
        .step-number {
          position: absolute;
          top: -25px;
          left: -25px;
          background: #ff6b6b;
          color: white;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
        }
        .cta-section {
          border-radius: 20px;
          text-shadow: 0 0 10px rgba(0, 0, 0, 0.689);
        }
        .pulse {
          animation: pulse 2s infinite;
        }
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
        }
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.05); }
          100% { transform: scale(1); }
        }
        .feature-card {
          background: rgba(255,255,255,0.9);
          backdrop-filter: blur(10px);
          padding: 2rem;
          border-radius: 15px;
          transition: all 0.3s ease;
        }
        .feature-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 30px rgba(255,255,255,0.5);
        }
      `}</style>
    </>
  );
};

export default HowToApply;
